import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { session } from "@/lib/auth";

/**
 * Pathless layout: everything under it requires a signed-in user. Portal
 * layouts (admin/org/me) add the role check on top. Client guards are UX only;
 * the API re-enforces roles and tenancy on every request.
 */
export const Route = createFileRoute("/_authenticated")({
  beforeLoad: ({ location }) => {
    if (!session.isAuthenticated()) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }
  },
  component: () => <Outlet />,
});
